// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoardEdit_wrapper__Mavli"};